// Bio live-refresh: solitude/bed restores write npcsRef without react state,
// so while a bio is open, publish refs to state every 2s (fresh energy,
// sleep timers, relationship scores). Idle cost: one small re-render.
import { useEffect, type MutableRefObject } from 'react';
import type { Npc } from '../types.js';

export function useBioRefresh(
  bioId: string | null,
  npcsRef: MutableRefObject<Npc[]>,
  setNpcs: (npcs: Npc[]) => void,
): void {
  useEffect(() => {
    if (!bioId) return;
    const t = setInterval(() => setNpcs([...npcsRef.current]), 2000);
    return () => clearInterval(t);
  }, [bioId, npcsRef, setNpcs]);
}
